import { ParkingPageId } from '../../../../domain/pages/ParkingPageId';
import { useNewBookingStore } from '../../../../domain/booking/stores/useNewBookingsStore';
import { useValidationResultMemo } from './useValidationResultMemo';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';

export function useHasParkingProduct() {
	const {
		booking: { parkingProduct },
	} = useNewBookingStore();

	return !!parkingProduct;
}

export function useParkingProductValidation() {
	const isValid = useHasParkingProduct();
	const redirectUrl = useUrlForPageId(ParkingPageId.NewBookingAvailability);

	return useValidationResultMemo({
		isValid,
		redirectUrl,
	});
}
